<template>
  <div class="block block-rounded block-fx-shadow">
    <div class="block-header">
      <h3 class="block-title"><font-awesome-icon icon="user" /> {{ $t('debtors.info') }}</h3>
      <div class="block-options">
          <button class="btn btn-sm btn-alt-primary" v-if="!editDebtor" @click.prevent="handleEditDebtor()">
            <i class="fa fa-edit"></i> {{ $t('buttons.edit') }}
          </button>
          <button class="btn btn-sm btn-alt-danger" v-if="editDebtor" @click.prevent="handleEditDebtor()">
            <i class="fa fa-times"></i> {{ $t('buttons.cancel') }}
          </button>
      </div>
    </div>
    <div class="block-content">
      <form @submit.stop.prevent="updateDebtor">
        <div class="form-group row">
          <div class="col">
            <label for="UpdateLastname" class="col-form-label">{{ $t('debtors.lastname') }}</label>
            <input type="text" class="form-control" v-model="adminDebtor.lastname" :class="{'is-invalid': errors.lastname }" id="UpdateLastname" :readonly="!editDebtor">
            <span v-if="errors.lastname" class="invalid-feedback">
                <strong>{{errors.lastname ? errors.lastname[0] : '' }}</strong>
            </span>
          </div>
          <div class="col">
            <label for="Updatefirstname" class="col-form-label">{{ $t('debtors.firstname') }}</label>
            <input type="text" class="form-control" v-model="adminDebtor.firstname" :class="{'is-invalid': errors.firstname }" id="Updatefirstname" :readonly="!editDebtor">
            <span v-if="errors.firstname" class="invalid-feedback">
                <strong>{{ errors.firstname ? errors.firstname[0] : '' }}</strong>
            </span>
          </div>
          <div class="col">
            <label for="Updatemiddlename" class="col-form-label">{{ $t('debtors.middlename') }}</label>
            <input type="text" class="form-control" v-model="adminDebtor.middlename" :class="{'is-invalid': errors.middlename }" id="Updatemiddlename" :readonly="!editDebtor">
            <span v-if="errors.middlename" class="invalid-feedback">
                <strong>{{ errors.middlename ? errors.middlename[0] : '' }}</strong>
            </span>
          </div>
        </div>
        <div class="form-group row">
          <div class="col">
            <label for="UpdateIin" class="col-form-label">{{ $t('debtors.iin') }}</label>
            <input type="text" class="form-control" v-model="adminDebtor.iin" :class="{'is-invalid': errors.iin }" id="UpdateIin" :readonly="!editDebtor">
            <span v-if="errors.iin" class="invalid-feedback">
                <strong>{{ errors.iin ? errors.iin[0] : '' }}</strong>
            </span>
          </div>
          <div class="col">
            <label for="UpdatebirthDay" class="col-form-label">{{ $t('debtors.birth_day') }}</label>
            <input type="date" class="form-control" v-model="adminDebtor.birth_day" :class="{'is-invalid': errors.birth_day }" id="UpdatebirthDay" :readonly="!editDebtor">
            <span v-if="errors.birth_day" class="invalid-feedback">
                <strong>{{ errors.birth_day ? errors.birth_day[0] : '' }}</strong>
            </span>
          </div>
        </div>
        <div class="form-group row">
          <div class="col">
            <label for="UpdateIdCardNumber" class="col-form-label">{{ $t('debtors.id_card_number') }}</label>
            <input type="text" class="form-control" v-model="adminDebtor.id_card_number" :class="{'is-invalid': errors.id_card_number }" id="UpdateIdCardNumber" :readonly="!editDebtor">
            <span v-if="errors.id_card_number" class="invalid-feedback">
                <strong>{{ errors.id_card_number ? errors.id_card_number[0] : '' }}</strong>
            </span>
          </div>
          <div class="col">
            <label for="UpdateidCardWhoIssued" class="col-form-label">{{ $t('debtors.id_card_who_issued') }}</label>
            <input type="text" class="form-control" v-model="adminDebtor.id_card_who_issued" :class="{'is-invalid': errors.id_card_who_issued }" id="UpdateidCardWhoIssued" :readonly="!editDebtor">
            <span v-if="errors.id_card_who_issued" class="invalid-feedback">
                <strong>{{ errors.id_card_who_issued ? errors.id_card_who_issued[0] : '' }}</strong>
            </span>
          </div>
        </div>
        <div class="form-group row">
          <div class="col">
            <label for="UpdateIdCardStartDate" class="col-form-label">{{ $t('debtors.id_card_start_date') }}</label>
            <input type="date" class="form-control" v-model="adminDebtor.id_card_start_date" :class="{'is-invalid': errors.id_card_start_date }" id="UpdateIdCardStartDate" :readonly="!editDebtor">
            <span v-if="errors.id_card_start_date" class="invalid-feedback">
                <strong>{{ errors.id_card_start_date ? errors.id_card_start_date[0] : '' }}</strong>
            </span>
          </div>
          <div class="col">
            <label for="UpdateAmountCreditDate" class="col-form-label">{{ $t('debtors.id_card_end_date') }}</label>
            <input type="date" class="form-control" v-model="adminDebtor.id_card_end_date" :class="{'is-invalid': errors.id_card_end_date }" id="UpdateAmountCreditDate" :readonly="!editDebtor">
            <span v-if="errors.id_card_end_date" class="invalid-feedback">
                <strong>{{ errors.id_card_end_date ? errors.id_card_end_date[0] : '' }}</strong>
            </span>
          </div>
        </div>
        <div class="form-group row">
          <div class="col">
            <label for="UpdateRnn" class="col-form-label">{{ $t('debtors.rnn') }}</label>
            <input type="text" class="form-control" v-model="adminDebtor.rnn" :class="{'is-invalid': errors.rnn }" id="UpdateRnn" :readonly="!editDebtor">
            <span v-if="errors.rnn" class="invalid-feedback">
                <strong>{{ errors.rnn ? errors.rnn[0] : '' }}</strong>
            </span>
          </div>
          <div class="col">
            <label for="UpdateSik" class="col-form-label">{{ $t('debtors.sik') }}</label>
            <input type="text" class="form-control" v-model="adminDebtor.sik" :class="{'is-invalid': errors.sik }" id="UpdateSik" :readonly="!editDebtor">
            <span v-if="errors.sik" class="invalid-feedback">
                <strong>{{ errors.sik ? errors.sik[0] : '' }}</strong>
            </span>
          </div>
        </div>
        <div class="form-group row">
          <div class="col">
            <div class="float-right">
              <button type="submit" class="btn btn-primary" v-if="editDebtor">
                <i class="fa fa-save" v-if="!isProcessing"></i> <i class="fa fa-spinner fa-pulse" v-if="isProcessing"></i> {{ $t('buttons.save') }}
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  data() {
    return {
      editDebtor: false,
      errors: {},
      isProcessing: false,
    };
  },
  computed: {
    ...mapGetters([
      'adminDebtor',
    ]),
  },
  methods: {
    ...mapActions([
      'GET_ADMIN_DEBTOR',
      'UPDATE_ADMIN_DEBTOR',
    ]),

    handleEditDebtor() {
      if (this.editDebtor) {
        this.editDebtor = false;
      } else {
        this.editDebtor = true;
      }
    },

    updateDebtor() {
      this.isProcessing = true;
      this.UPDATE_ADMIN_DEBTOR(this.adminDebtor)
        .then(() => {
          this.GET_ADMIN_DEBTOR(this.$route.params.id);
          this.editDebtor = false;
        })
        .catch((err) => {
          this.errors = this.laravelValidation(err);
        })
        .finally(() => {
          this.isProcessing = false;
        });
    },
  },
};
</script>
